'use client';

import { useEffect, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import Snackbar from '@/components/Snackbar';
import { useConfig } from '@/app/contexts/ConfigContext';

export default function AlreadySub() {
  const { config } = useConfig();

  const params = useSearchParams();

  const toast = params.get('tst');

  const [host, setHost] = useState('');

  useEffect(() => {
    setHost(window.location.hostname);
  }, []);

  // All case to display this snackbar
  const isLocalhost = host === 'localhost' || host === '127.0.0.1';
  const isTestingEnv = host.startsWith('testing');
  const norskPortal =
    config.SERVICE_URL_LINK === 'noportal.apptitude.live';

  const showAlreadySubSnackbar = isLocalhost || isTestingEnv || norskPortal;

  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (toast !== '1' && toast !== '2') return;

    if (toast === '1' || toast === '2') {
      setSnackbarVisible(true);
      const t = setTimeout(() => {
        setSnackbarVisible(false);
      }, 5000);

      if (toast === '1') {
        setMsg('Du er allerede abonnert'); // You are already subscribed
      } else if (toast === '2') {
        setMsg('Velkommen!'); // Welcome !
      }

      return () => clearTimeout(t);
    }
  }, [params, toast]);

  return (
    <>
      {showAlreadySubSnackbar && snackbarVisible && (
        <Snackbar
          show={snackbarVisible}
          message={msg}
          onClose={() => setSnackbarVisible(false)}
          bgColor={config.theme.accentColorOne}
          textColor={config.theme.textColorDark}
        />
      )}
    </>
  );
}
